import { createReducer } from '@reduxjs/toolkit';

import { searchHistoryAdded, searchHistoryCleared, searchHistoryReceived } from './search-history-actions';

export interface SearchHistoryState {
    searchHistory: string[];
}

const initialState: SearchHistoryState = {
    searchHistory: [],
};

export const searchHistoryReducer = createReducer(initialState, builder => {
    builder.addCase(searchHistoryReceived, (state, action) => ({ ...state, searchHistory: action.payload }));
    builder.addCase(searchHistoryCleared, state => ({ ...state, searchHistory: [] }));
    builder.addCase(searchHistoryAdded, (state, action) => {
        const newSearchHistory = [...state.searchHistory];
        const index = newSearchHistory.indexOf(action.payload);
        if (index > -1) {
            newSearchHistory.splice(index, 1);
        }
        newSearchHistory.unshift(action.payload);
        if (newSearchHistory.length > 13) {
            newSearchHistory.pop();
        }
        return { ...state, searchHistory: newSearchHistory };
    });
});
